import React, { useState, useRef } from 'react';
import { useImportTasks } from '../../hooks/useImportTasks';
import ImportInfoModal from '../../../../ui/components/ImportInfoModal/ImportInfoModal';

/**
 * Self-contained import popup: modal + file input + handlers.
 * Use renderTrigger to render a button (or other control) that opens the popup.
 * renderTrigger receives { open } so the parent can call open() on click (e.g. after requireAuth).
 */
function ImportPopup({ renderTrigger }) {
  const [isOpen, setIsOpen] = useState(false);
  const fileInputRef = useRef(null);
  const { handleImportPasted, handleFileChange } = useImportTasks();

  const openPopup = () => setIsOpen(true);
  const closePopup = () => setIsOpen(false);

  const handleChooseFile = () => {
    closePopup();
    fileInputRef.current?.click();
  };

  const handleImportPastedClose = (text) => {
    closePopup();
    handleImportPasted(text);
  };

  return (
    <>
      {renderTrigger != null && renderTrigger({ open: openPopup })}
      <ImportInfoModal
        isOpen={isOpen}
        onClose={closePopup}
        onChooseFile={handleChooseFile}
        onImportPasted={handleImportPastedClose}
      />
      <input
        ref={fileInputRef}
        type="file"
        accept=".txt"
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
    </>
  );
}

export default ImportPopup;
